import callAPI from 'api'

export type GetMasterBranchPayload = {
  branch_id: string
}

export type BranchFeatureAccessor = 'quotation'

export type MasterBranch = {
  branch_id: string
  branch_name: string
  country_code: string
  currency_iso: string
  currency_symbol: string
  features: Array<{
    name: string
    accessor: BranchFeatureAccessor
    is_active: boolean
  }>
}

const getMasterBranch = async (payload: GetMasterBranchPayload) =>
  await callAPI<MasterBranch, GetMasterBranchPayload>('crm_get_master_branch', [payload], {
    requireAuthorization: true,
  })

export default {
  getMasterBranch,
}
